<template>
    <Modal class="alert-modal"
           :class="headerColorClass"
           :icon="icon"
           :title="title"
           :custom-title-text="customTitleText"
           :size="modalSize">
        <DialogText :text-lang-keys="textLangKeys"
                    :custom-text="customText"
                    :custom-html="customHtml" />

        <template v-slot:footer>
            <div class="modl-footer">
                <DialogOkBtn :color="okColor"
                             :custom-text="okCustomText"
                             :label="okLabel"
                             @click="resolve(true)" />
            </div>
        </template>
    </Modal>
</template>

<script>
import DialogOkBtn from '@/vue/modals/Dialogs/components/DialogOkBtn';
import DialogText from '@/vue/modals/Dialogs/components/DialogText';
import Modal from '@/vue/components/Modals/Modal';
import { DialogPropsMixin } from '@/vue/modals/Dialogs/mixins/DialogPropsMixin';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: {
        Modal,
        DialogOkBtn,
        DialogText,
    },

    mixins: [
        ModalPropsMixin,
        DialogPropsMixin,
    ],
};
</script>

<style lang="less">
@import (reference) "../../../less/variables";

.alert-modal {
    z-index: @vue-modal-z-index--priority;

    p {
        font-size: @font-size-large;
    }
}
</style>
